import React from 'react'
import './NumberInput.css'

export default function NumberInput(props) {
    return (
        <div className='numberInputContainer' style={props.containerStyles}>
            <p className='numberInputTitle' style={props.titleStyles}>{props.title}</p>
            <input type='number' className='numberInputBody' step={props.step} value={props.value} name={props.name} min={props.min} onChange={props.onChange} style={props.inputStyles} />
            <span className="error">{props.formSubmitted && props.errors}</span>
        </div>
    )
}
